import React, { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
//import MapBoxProject from "./components/map/MapBoxProject";
import MapboxAPI from "./components/map/MapboxAPI";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import DashboardIcon from "@mui/icons-material/Dashboard";

import ArticleIcon from "@mui/icons-material/Article";
// import ProjectsTable from "./projects/ProjectsTable";
import ProjectsTableCombination from "./projects/ProjectTableCombination";
// import ChartDoughnut from "./projects/dashboard/ChartDoughnut";
// import ChartLine from "./projects/dashboard/ChartLine";
import ChartBar from "./projects/dashboard/ChartBar";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
// import { ReactComponent as MollierDiagramIcon } from "../image/mollierDiagramIcon.svg";
// import Tooltip from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../actions/snackbarActions";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import {
  getProjects,
  // getDashboardData,
} from "../utils/services/projectService";
import {
  getBasicChartData,
  getUnitTypesChart,
  // getAirFlowChart,
  getTypesAndCostsChartData,
} from "../utils/services/homeService";
// import config from "../utils/config";
import "animate.css";
// import { useMemo } from "react";
import { Provider } from "../../src/utils/hooks/filterContext";

// import { filterContext } from "../../src/utils/hooks/filterContext";

import {
  // logIn,
  logOut,
  // refreshTokenAction,
  // setCookieInLocalStorage,
} from "../actions/authActions";
const initialFilter = {
  items: [
    {
      columnField: "id",
      operator: "contains",
      operatorValue: "contains",
      value: "",
    },
  ],
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function Home() {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [projectsLoaded1, setProjectLoaded1] = useState(false);
  const [, setProjectLoaded2] = useState(false);
  const [projectsLoaded3, setProjectLoaded3] = useState(false);
  const [projectsLoaded, setProjectsLoaded] = useState(false);

  const [basicChartdata, setBasicChartdata] = useState({});
  const [unitTypesChart, setUnitTypesChart] = useState([]);
  const [unitTypeCostsChart, setUnitTypeCostsChart] = useState([]);
  // const [airflowChart, setAirflowChart] = useState([]);
  const [dataExist, setDataExist] = useState(false);
  const [projects, setProjects] = useState([]);
  const theme = useTheme();
  // var memoProjects;

  /*Primer kako da menjamo stanje samo ako vrednosti nisu iste   
if (hookState.num !== newHookState.num){
  setHookState(newHookState)
}*/

  const [filterParameters, setFilterParameters] = useState(initialFilter);

  const { t } = useTranslation();
  const goToCreateProject = () => {
    window.scrollTo(0, 0);
    navigate("/create-project");
  };

  useEffect(() => {
    //setProjectLoaded(false);
    /* getDashboardData()
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300)
          // setDashboardData(res.data.data);
          console.log(res);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", t("snackbar.fetchingDataError")));
      });*/
    /* getBasicChartData()
      .then((res) => {
        setBasicChartdata(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getUnitTypesChart()
      .then((res) => {
        setUnitTypesChart(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getAirFlowChart()
      .then((res) => {
        setAirflowChart(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });*/
    console.log("Home ucitavam inicijalne podatke");
    refreshDashboardData("", "", "");
    getProjects()
      .then((res) => {
        if (res.data.length === 0) setProjectsLoaded(true);
        if (
          res.statusCode >= 200 &&
          res.statusCode < 300 &&
          res.data.length !== 0
        ) {
          //memoProjects = React.useMemo(() => res.data);

          setProjects(res.data);
        } // else setLoading(false);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", t("snackbar.fetchingDataError")));
      });
  }, []);

  function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
      : "0";
  }

  useEffect(() => {
    //  if () setProjectLoaded(true);
    /* setProjectLoaded1(false);
    setProjectLoaded2(false);
    setProjectLoaded3(false);*/
    console.log("Home proveravam skeletone");
    if (Object.keys(basicChartdata).length !== 0) setProjectLoaded1(true);
    if (unitTypesChart.length !== 0) setProjectLoaded2(true);
    if (unitTypeCostsChart.length !== 0) setProjectLoaded3(true);
    if (projects.length !== 0) setProjectsLoaded(true);
  }, [unitTypesChart, unitTypeCostsChart, basicChartdata, projects]);

  ////.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")

  /* const refreshDashboardData = useCallback((col, op, val) => {
    //function refreshDashboardData(col, op, val) {
    console.log("Home ucitavam nove podatke po filterima sa beka");
    setProjectLoaded1(false);
    setProjectLoaded2(false);
    setProjectLoaded3(false);
    getBasicChartData(col, op, val)
      .then((res) => {
        if (res.data.data.numberOfProjects !== 0) setDataExist(true);
        setBasicChartdata(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getUnitTypesChart(col, op, val)
      .then((res) => {
        setUnitTypesChart(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getAirFlowChart(col, op, val)
      .then((res) => {
        setAirflowChart(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);*/

  const refreshDashboardData = (col, op, val) => {
    //function refreshDashboardData(col, op, val) {
    console.log("Home ucitavam nove podatke po filterima sa beka");
    setProjectLoaded1(false);
    setProjectLoaded2(false);
    setProjectLoaded3(false);
    getBasicChartData(col, op, val)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          if (res.data.data.numberOfProjects !== 0) setDataExist(true);
          setBasicChartdata(res.data.data);
        } else if (res.statusCode === 401) {
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
          setTimeout(() => {
            dispatch(logOut());
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    getUnitTypesChart(col, op, val)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          setUnitTypesChart(res.data.data);
        } else if (res.statusCode === 401) {
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
          setTimeout(() => {
            dispatch(logOut());
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    getTypesAndCostsChartData(col, op, val)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          if (res.data.length === 0) setProjectLoaded3(true);
          setUnitTypeCostsChart(res.data.data);
        } else if (res.statusCode === 401) {
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
          setTimeout(() => {
            dispatch(logOut());
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    /* getAirFlowChart(col, op, val)
      .then((res) => {
        setAirflowChart(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });*/
  };

  useEffect(() => {
    setProjectLoaded1(false);
    setProjectLoaded2(false);
    setProjectLoaded3(false);
    getBasicChartData(
      filterParameters.items[0].columnField,
      filterParameters.items[0].operatorValue,
      filterParameters.items[0].value
    )
      .then((res) => {
        if (res.data.data.numberOfProjects !== 0) setDataExist(true);
        setBasicChartdata(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

    getTypesAndCostsChartData(
      filterParameters.items[0].columnField,
      filterParameters.items[0].operatorValue,
      filterParameters.items[0].value
    )
      .then((res) => {
        if (res.data.data.length === 0) setProjectLoaded3(true);
        setUnitTypeCostsChart(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [filterParameters]);

  return (
    <Provider
      value={{
        filterParameters,
        setFilterParameters,
      }}
    >
      <Container
        className="flex-mobile"
        component="main"
        maxWidth="false"
        sx={{
          // minHeight: "90vh",
          minHeight: "calc(100vh - 250px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ paddingTop: "10px", width: "100%" }}>
          {dataExist ? (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  color: theme.palette.primary.main,
                }}
              >
                <DashboardIcon sx={{ width: 50, height: 50, m: 1 }} />
                <Typography
                  component="h1"
                  variant="h5"
                  sx={{ margin: 2, color: theme.palette.primary.main }}
                >
                  {t("home.mydashboard")}
                </Typography>
              </Box>
              <Divider sx={{ mb: 4 }} />
              <Box
                sx={{
                  display: "flex",
                  flexFlow: "wrap",
                  justifyContent: "space-around",
                }}
              >
                <Box
                  maxWidth="xs"
                  sx={{
                    width: { xs: 300, sm: 300, md: 300, lg: 400, xl: 400 },
                    height: { xs: 300, sm: 300, md: 300, lg: 400, xl: 400 },
                    // marginLeft: { xs: 15, xl: 15 },
                    display: "flex",
                    justifyContent: "center",
                    marginTop: { xs: 0, lg: 5 },
                  }}
                >
                  {projectsLoaded1 ? (
                    <Paper elevation={0}>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography fontSize={46}>
                          {basicChartdata.numberOfProjects}
                        </Typography>
                        <Typography fontSize={16}>
                          {t("home.numOfProjects")}
                        </Typography>
                        <Typography fontSize={46}>
                          {basicChartdata.numberOfUnits}
                        </Typography>
                        <Typography fontSize={16}>
                          {t("home.numOfUnits")}
                        </Typography>
                        <Typography fontSize={46}>
                          €{nFormatter(basicChartdata.sumOfCosts, 2)}
                        </Typography>
                        <Typography fontSize={16}>
                          {t("home.sumOfProjCost")}
                        </Typography>
                      </Grid>
                    </Paper>
                  ) : (
                    <Stack
                      spacing={1}
                      justifyContent="start"
                      alignItems="center"
                      sx={{
                        marginLeft: { xs: 5, lg: 10 },
                      }}
                    >
                      <Skeleton
                        variant="text"
                        width={50}
                        sx={{ fontSize: 46 }}
                      />
                      <Skeleton
                        variant="text"
                        width={120}
                        sx={{ fontSize: 16 }}
                      />
                      <Skeleton
                        variant="text"
                        width={50}
                        sx={{ fontSize: 46 }}
                      />
                      <Skeleton
                        variant="text"
                        width={120}
                        sx={{ fontSize: 16 }}
                      />
                      <Skeleton
                        variant="text"
                        width={50}
                        sx={{ fontSize: 46 }}
                      />
                      <Skeleton
                        variant="text"
                        width={120}
                        sx={{ fontSize: 16 }}
                      />
                    </Stack>
                  )}
                </Box>
                {/*<Box
                maxWidth="xs"
                sx={{
                  width: { xs: 300, sm: 300, md: 300, lg: 400, xl: 400 },
                  height: { xs: 300, sm: 300, md: 300, lg: 400, xl: 400 },
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginTop: { xs: 0, lg: 3 },
                }}
              >
                {projectsLoaded2 ? (
                  <>
                    <ChartDoughnut
                      position="relative"
                      data={unitTypesChart}
                    ></ChartDoughnut>
                    {unitTypesChart.length === 0 && (
                      <Typography position="absolute" marginTop={5}>
                        No available data. Please refine your filter search.
                      </Typography>
                    )}{" "}
                  </>
                ) : (
                  <Stack
                    spacing={1}
                    justifyContent="start"
                    alignItems="center"
                    sx={{
                      marginLeft: { xs: 8, lg: 12 },
                      marginTop: { xs: 1, lg: 1 },
                    }}
                  >
                    <Skeleton
                      variant="text"
                      width={100}
                      sx={{ fontSize: 16 }}
                    />
                    <Stack
                      spacing={1}
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Skeleton variant="rounded" width={50} height={15} />
                      <Skeleton variant="rounded" width={50} height={15} />
                      <Skeleton variant="rounded" width={50} height={15} />
                    </Stack>

                    <Skeleton variant="circular" width={220} height={220} />
                  </Stack>
                  )}
              </Box>*/}
                <Box
                  maxWidth="xs"
                  sx={{
                    width: { xs: 350, sm: 400, md: 500, lg: 400, xl: 700 },
                    height: { xs: 200, sm: 300, md: 400, lg: 400, xl: 400 },
                    display: "flex",

                    alignItems: "flex-start",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  {projectsLoaded3 ? (
                    <>
                      <ChartBar
                        position="relative"
                        data={unitTypeCostsChart}
                      ></ChartBar>
                      {unitTypeCostsChart.length === 0 && (
                        <Typography
                          position="absolute"
                          marginLeft={20}
                          sx={{
                            marginLeft: { xs: 5, lg: 15 },
                            marginTop: { xs: 5, lg: 10 },
                          }}
                        >
                          No available data. Please refine your filter search.
                        </Typography>
                      )}{" "}
                    </>
                  ) : (
                    <Stack
                      spacing={1}
                      justifyContent="start"
                      alignItems="center"
                      sx={{
                        marginLeft: { xs: 4, lg: 16 },
                        marginTop: { xs: 5, lg: 5 },
                      }}
                    >
                      <Skeleton
                        variant="text"
                        width={100}
                        sx={{ fontSize: 16 }}
                      />
                      <Stack
                        spacing={1}
                        direction="row"
                        justifyContent="start"
                        alignItems="center"
                      >
                        <Skeleton variant="rounded" width={100} height={15} />
                        <Skeleton variant="rounded" width={100} height={15} />
                      </Stack>
                      <Skeleton variant="rounded" width={350} height={200} />{" "}
                    </Stack>
                  )}
                </Box>
              </Box>
            </Box>
          ) : (
            <></>
          )}

          <Box style={{}}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: theme.palette.primary.main,
                m: 1,
              }}
            >
              {dataExist && (
                <>
                  <ArticleIcon sx={{ width: 50, height: 50 }} />
                  <Typography
                    component="h1"
                    variant="h5"
                    sx={{ margin: 2, color: theme.palette.primary.main }}
                  >
                    {t("home.projects")}
                  </Typography>
                </>
              )}
            </Box>
            {dataExist && <Divider sx={{ mb: 3 }} />}
            <Box
              sx={{
                m: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                onClick={goToCreateProject}
                className="animate__animated animate__flash animate__repeat-1 animate__delay-2s animate__slow"
                sx={{
                  mt: 2,
                  mb: 2,
                  backgroundColor: "#5cc1f1",
                  color: "white",
                  padding: "8px 40px",
                  fontSize: 26,
                  transition: "all 0.5s",
                  "&:hover": {
                    backgroundColor: "#4a9bc7",
                    transform: "scale(1.05)",
                  },
                }}
              >
                {t("home.newprojectbtn")}
              </Button>
            </Box>
            {dataExist && <Divider sx={{ mb: 3, mt: 3 }} />}
          </Box>
          {dataExist && (
            <Box sx={{ width: "100%" }}>
              {projectsLoaded ? (
                <ProjectsTableCombination
                  projects={projects}
                  refreshDashboardData={refreshDashboardData}
                ></ProjectsTableCombination>
              ) : (
                <Box sx={{ width: "100%", height: "75vh" }}>
                  <Stack
                    spacing={1}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Skeleton
                      variant="rectangular"
                      sx={{ width: "100%", height: "5vh" }}
                    />
                    <Skeleton
                      variant="rectangular"
                      sx={{ width: "100%", height: "5vh" }}
                    />
                    <Skeleton
                      variant="rectangular"
                      sx={{ width: "100%", height: "5vh" }}
                    />
                    <Skeleton
                      variant="rectangular"
                      sx={{ width: "100%", height: "5vh" }}
                    />
                  </Stack>
                </Box>
              )}
            </Box>
          )}
          {dataExist && (
            <Box sx={{ m: 0, p: 0 }}>
              {projectsLoaded ? (
                <MapboxAPI
                  zoom={4}
                  componentDisplay={"projectsMap"}
                  projects={projects}
                />
              ) : (
                <Box sx={{ width: "100%", height: "75vh" }}>
                  <Stack
                    spacing={1}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Skeleton
                      variant="rectangular"
                      sx={{ width: "100%", height: "30vh" }}
                    />
                  </Stack>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Container>
    </Provider>
  );
}

//Home.whyDidYouRender = true;

export default Home;
